import { personalEmailProviders, TokenKeyName } from "../../../Constant/Setting"
import colors from "../../../assets/styles/variables.module.scss"
import Strength from "../../Types/Auth"

export function SetSession(token: string) {
    window.localStorage.setItem(TokenKeyName, token)
}


export function ClearSession() {
    window.localStorage.removeItem(TokenKeyName)
}

export function GetSession() {
    return window.localStorage.getItem(TokenKeyName)
}



//   Password validator for register pages 

const hasNumber = (password: string) => new RegExp(/[0-9]/).test(password)
const hasMixed = (password: string) => new RegExp(/[a-z]/).test(password) && new RegExp(/[A-Z]/).test(password)
const hasSpecial = (password: string) => new RegExp(/[!#@$%^&*)(+=._-]/).test(password)

function StrengthColor(strengthNum: number): Strength {
    if (strengthNum < 2) return { label: 'Poor', color: colors.errorMain, strength: "20", };
    if (strengthNum < 3) return { label: 'Weak', color: colors.warningDark, strength: "40", };
    if (strengthNum < 4) return { label: 'Normal', color: colors.warningLight, strength: "60", };
    if (strengthNum < 5) return { label: 'Good', color: colors.successMain, strength: "80", };
    if (strengthNum < 6) return { label: 'Strong', color: colors.successDark, strength: "100", };
    return { label: "Poor", color: "test", strength: "20%", }
}

export function PasswordStrengthCheck(password: string): Strength {
    let strength = 0
    if (password.length > 5) strength += 1
    if (password.length > 7) strength += 1
    if (hasNumber(password)) strength += 1
    if (hasMixed(password)) strength += 1
    if (hasSpecial(password)) strength += 1
    return StrengthColor(strength)
}


export function ValidateIsEmail(email: string): boolean {
    return new RegExp(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/).test(email.trim())
}

export function ValidateEmailIsOrg(email: string): boolean {
    const domain = email.split('@')[1]
    return !personalEmailProviders.includes(domain)
}